import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/custom-purchase/`;

// Create a custom purchase link for a registered customer profile.
// payload: { items: [{url, price, qty, deliveryFeeJp, imageUrl?}], description, customerId, isAir }
// → { id, token, checkoutUrl }
const createCustomLink = async (payload) => {
  return await axios.post(API_URL + 'create', payload);
};

// List the shop's created links → [{ id, token, checkoutUrl, status, totalAmount,
// itemCount, description, createdAt, paidAt, customer:{smileName,contact} }]
const listCustomLinks = async (shop) => {
  return await axios.get(API_URL + 'list', { params: { shop } });
};

// Cancel a pending link made by mistake (the customer then sees "cancelled,
// contact admin"); the admin issues a new one instead. Paid links → 409.
const cancelCustomLink = async (id) => {
  return await axios.post(API_URL + `${id}/cancel`);
};

export default { createCustomLink, listCustomLinks, cancelCustomLink };
